import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

export const useEntityAnimationStateManager = /* @__PURE__ */ create(
  /* @__PURE__ */ subscribeWithSelector<State>((set) => {
    return {
      /**
       * Character animations state manegement
       */
      // Initial animation
      curAnimation: null as unknown as string,
      animationSet: {} as AnimationSet,

      initializeAnimationSet: (animationSet: AnimationSet) => {
        set((state) => {
          if (Object.keys(state.animationSet).length === 0) {
            return { animationSet };
          }
          return {};
        });
      },

      reset: () => {
        set((state) => {
          return { curAnimation: state.animationSet.idle };
        });
      },

      idle: () => {
        set((state) => {
          return { curAnimation: state.animationSet.idle };
        });
      },

      walk: () => {
        set((state) => {
          return { curAnimation: state.animationSet.walk };
        });
      },

      run: () => {
        set((state) => {
          return { curAnimation: state.animationSet.run };
        });
      },

      castSpell: () => {
        set((state) => {
          return { curAnimation: state.animationSet.castSpell };
        });
      },

      recieveHit: () => {
        set((state) => {
          return { curAnimation: state.animationSet.recieveHit };
        });
      },

      release: () => {
        set((state) => {
          return { curAnimation: state.animationSet.release };
        });
      },

      /**
       * Additional animations
       */
      // triggerFunction: ()=>{
      //    set((state) => {
      //        return { curAnimation: state.animationSet.additionalAnimation };
      //    });
      // }
    };
  })
);

export type AnimationSet = {
  idle: string;
  walk: string;
  run: string;
  castSpell: string;
  recieveHit: string;
  release: string;
};

type State = {
  curAnimation: string;
  animationSet: AnimationSet;
  initializeAnimationSet: (animationSet: AnimationSet) => void;
  reset: () => void;
} & {
  [key in keyof AnimationSet]: () => void;
};
